// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iWn2","textarea":"styles_textarea__1TPVg"};